import { render, staticRenderFns } from "./PlaceImport.vue?vue&type=template&id=44e4b9b0&scoped=true&"
import script from "./PlaceImport.vue?vue&type=script&lang=js&"
export * from "./PlaceImport.vue?vue&type=script&lang=js&"
import style0 from "./PlaceImport.vue?vue&type=style&index=0&id=44e4b9b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e4b9b0",
  null
  
)

export default component.exports